(function () {
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealThumb(rail, thumb) {
    if (!rail || !thumb) return;
    var railRect = rail.getBoundingClientRect();
    var thumbRect = thumb.getBoundingClientRect();
    var vertical = rail.scrollHeight > rail.clientHeight + 1;
    if (vertical) {
      if (thumbRect.top < railRect.top) {
        rail.scrollTop -= railRect.top - thumbRect.top;
      } else if (thumbRect.bottom > railRect.bottom) {
        rail.scrollTop += thumbRect.bottom - railRect.bottom;
      }
      return;
    }
    if (thumbRect.left < railRect.left) {
      rail.scrollLeft -= railRect.left - thumbRect.left;
    } else if (thumbRect.right > railRect.right) {
      rail.scrollLeft += thumbRect.right - railRect.right;
    }
  }

  function bind(slider) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    if (!slider || slider.dataset.mkGalleryBound === 'true') return;
    var gallery = slider.closest('[data-pdp-gallery]');
    if (!gallery) return;
    slider.dataset.mkGalleryBound = 'true';

    var prev = gallery.querySelector('[data-pdp-gallery-prev]');
    var next = gallery.querySelector('[data-pdp-gallery-next]');
    var rail = gallery.querySelector('[data-pdp-thumbs-rail]');
    var thumbFrame = gallery.querySelector('.product-detail__thumbnails');
    var thumbPrev = gallery.querySelector('[data-pdp-thumbs-prev]');
    var thumbNext = gallery.querySelector('[data-pdp-thumbs-next]');
    var count = gallery.querySelector('[data-pdp-media-count]');

    function setDisabled(button, value) {
      if (!button) return;
      var hadFocus = document.activeElement === button;
      button.disabled = value;
      if (!hadFocus || !value) return;
      var fallback = button === prev ? next : prev;
      if (fallback && !fallback.disabled) {
        fallback.focus();
        return;
      }
      var activeThumb = rail && rail.querySelector('[aria-current="true"]');
      if (activeThumb) activeThumb.focus();
    }

    function slideMediaId(slick, index) {
      var slide = slick.$slides && slick.$slides.get(index);
      if (!slide) return '';
      var media = slide.querySelector('[data-media-id]');
      return media ? String(media.getAttribute('data-media-id')) : '';
    }

    function markThumb(thumb) {
      if (!rail) return null;
      var active = null;
      rail.querySelectorAll('[data-product-media-thumbnail]').forEach(function (item) {
        var on = item === thumb;
        item.classList.toggle('thumb-active', on);
        if (on) {
          item.setAttribute('aria-current', 'true');
          active = item;
        } else {
          item.removeAttribute('aria-current');
        }
      });
      return active;
    }

    function sync(slick, index) {
      if (!slick || !slick.slideCount) return;
      if (typeof index !== 'number') index = slick.currentSlide;
      setDisabled(prev, index <= 0);
      setDisabled(next, index >= slick.slideCount - 1);
      var id = slideMediaId(slick, index);
      var active = null;
      if (rail) {
        rail.querySelectorAll('[data-product-media-thumbnail]').forEach(function (thumb) {
          if (thumb.getAttribute('data-media-id') === id) active = thumb;
        });
        active = markThumb(active);
      }
      if (count) count.textContent = active ? (active.getAttribute('aria-label') || '') : '';
      revealThumb(rail, active);
      syncThumbNav();
    }

    function railIsRow() {
      return rail && getComputedStyle(rail).flexDirection === 'row';
    }

    function syncThumbNav() {
      if (!rail || !thumbPrev || !thumbNext) return;
      var row = railIsRow();
      var max = row ? rail.scrollWidth - rail.clientWidth : rail.scrollHeight - rail.clientHeight;
      var pos = row ? rail.scrollLeft : rail.scrollTop;
      var overflow = max > 2;
      if (thumbFrame) thumbFrame.classList.toggle('is-paged', overflow);
      thumbPrev.hidden = !overflow;
      thumbNext.hidden = !overflow;
      thumbPrev.disabled = pos <= 1;
      thumbNext.disabled = pos >= max - 1;
    }

    function scrollThumbs(direction) {
      if (!rail) return;
      var thumb = rail.querySelector('.product-detail__thumbnail');
      if (!thumb) return;
      var row = railIsRow();
      var gap = parseFloat(getComputedStyle(rail).rowGap) || 8;
      var delta = (row ? thumb.getBoundingClientRect().width : thumb.getBoundingClientRect().height) + gap;
      rail.scrollBy(row
        ? { left: delta * direction, behavior: reducedMotion() ? 'auto' : 'smooth' }
        : { top: delta * direction, behavior: reducedMotion() ? 'auto' : 'smooth' });
    }

    function ready(slick) {
      if (reducedMotion() && slider.dataset.mkGalleryStill !== 'true') {
        slider.dataset.mkGalleryStill = 'true';
        $(slider).slick('slickSetOption', 'speed', 0, false);
      }
      sync(slick);
    }

    $(slider).on('init afterChange', function (_event, slick) {
      ready(slick);
    });

    $(slider).on('beforeChange', function (_event, slick, _current, next) {
      sync(slick, next);
    });

    if (slider.classList.contains('slick-initialized')) {
      ready($(slider).slick('getSlick'));
    }

    function step(direction) {
      if (!slider.classList.contains('slick-initialized')) return;
      $(slider).slick(direction > 0 ? 'slickNext' : 'slickPrev');
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (thumbPrev) thumbPrev.addEventListener('click', function () { scrollThumbs(-1); });
    if (thumbNext) thumbNext.addEventListener('click', function () { scrollThumbs(1); });
    if (rail) {
      rail.addEventListener('click', function (event) {
        var thumb = event.target.closest && event.target.closest('[data-product-media-thumbnail]');
        if (!thumb || !rail.contains(thumb)) return;
        markThumb(thumb);
      }, true);
      rail.addEventListener('scroll', syncThumbNav, { passive: true });
      if (window.ResizeObserver) {
        var thumbObserver = new ResizeObserver(syncThumbNav);
        thumbObserver.observe(rail);
      }
      syncThumbNav();
    }

    gallery.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (!event.target.closest) return;
      if (event.target.closest('.slick-list')) return;
      var thumb = event.target.closest('.product-detail__thumbnail');
      var nav = event.target.closest('.mk-pdp-gallery__nav');
      if (!thumb && !nav) return;
      var railStyle = rail ? getComputedStyle(rail) : null;
      var grid = railStyle && railStyle.display === 'grid';
      var columns = 1;
      if (grid) {
        columns = railStyle.gridTemplateColumns.split(' ').filter(Boolean).length || 6;
      }
      var horizontal = !grid && railStyle && railStyle.flexDirection === 'row';
      var stepCount = 1;
      var forward = false;
      var backward = false;
      if (thumb && grid) {
        if (event.key === 'ArrowRight') forward = true;
        if (event.key === 'ArrowLeft') backward = true;
        if (event.key === 'ArrowDown') {
          forward = true;
          stepCount = columns;
        }
        if (event.key === 'ArrowUp') {
          backward = true;
          stepCount = columns;
        }
      } else {
        forward = event.key === 'ArrowRight' || (!horizontal && event.key === 'ArrowDown');
        backward = event.key === 'ArrowLeft' || (!horizontal && event.key === 'ArrowUp');
        if (nav) {
          forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
          backward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
        }
      }
      if (!forward && !backward) return;
      if (!slider.classList.contains('slick-initialized')) return;
      event.preventDefault();
      if (thumb && rail) {
        var thumbs = Array.prototype.slice.call(rail.querySelectorAll('[data-product-media-thumbnail]'));
        var target = thumbs[thumbs.indexOf(thumb) + (forward ? stepCount : -stepCount)];
        if (!target) return;
        target.focus();
        var id = target.getAttribute('data-media-id');
        var slick = $(slider).slick('getSlick');
        var slideIndex = -1;
        slick.$slides.each(function (index, slide) {
          var media = slide.querySelector('[data-media-id]');
          if (media && media.getAttribute('data-media-id') === id) slideIndex = index;
        });
        if (slideIndex >= 0) $(slider).slick('slickGoTo', slideIndex);
        return;
      }
      step(forward ? 1 : -1);
    });
  }

  function boot() {
    document.querySelectorAll('.section-product-template .product-detail__images').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.section-product-template .product-detail__images').forEach(function (slider) {
      delete slider.dataset.mkGalleryBound;
    });
    boot();
  });
})();
